import { CONTACT, NAV_LINKS } from "@/lib/site";
import { Logo } from "@/components/site/Logo";

export default function Footer() {
  const go = (href) => {
    const el = document.querySelector(href);
    if (!el) return;
    if (window.lenis) window.lenis.scrollTo(el, { offset: -70, duration: 1.2 });
    else el.scrollIntoView({ behavior: "smooth" });
  };
  return (
    <footer data-testid="footer" className="relative bg-[#17320B] text-[#D9F4CD] border-t border-[#17320B] overflow-hidden">
      <div className="mx-auto max-w-[1400px] px-5 md:px-10 pt-16 pb-8">
        <div className="grid md:grid-cols-2 gap-10 mb-16">
          <div>
            <div className="flex items-center mb-5 text-[#D9F4CD]">
              <Logo className="text-3xl md:text-4xl" />
            </div>
            <p className="max-w-sm text-[#D9F4CD]/60 text-sm leading-relaxed">
              Smart vending machines dispensing fresh protein and wellness drinks, placed where
              performance happens.
            </p>
          </div>
          <div className="flex flex-col sm:flex-row gap-10 md:justify-end">
            <div>
              <div className="font-mono-eb text-[10px] uppercase tracking-[0.2em] text-[#7B9C62] mb-4">Explore</div>
              <div className="flex flex-col gap-2">
                {NAV_LINKS.map((l) => (
                  <button key={l.href} onClick={() => go(l.href)} className="text-left text-[#D9F4CD]/70 hover:text-[#C2E9FF] transition-colors duration-300 text-sm">
                    {l.label}
                  </button>
                ))}
              </div>
            </div>
            <div>
              <div className="font-mono-eb text-[10px] uppercase tracking-[0.2em] text-[#7B9C62] mb-4">Contact</div>
              <div className="flex flex-col gap-2 text-sm">
                <a href={`mailto:${CONTACT.email}`} className="text-[#D9F4CD]/70 hover:text-[#C2E9FF] transition-colors duration-300">{CONTACT.email}</a>
                <a href={`tel:${CONTACT.phoneRaw}`} className="text-[#D9F4CD]/70 hover:text-[#C2E9FF] transition-colors duration-300">{CONTACT.phone}</a>
                <a href="https://instagram.com/the.macro.bar" target="_blank" rel="noreferrer" className="text-[#D9F4CD]/70 hover:text-[#C2E9FF] transition-colors duration-300">{CONTACT.instagram}</a>
              </div>
            </div>
          </div>
        </div>

        <div className="leading-[0.8] tracking-tighter text-[15vw] text-transparent select-none" style={{ WebkitTextStroke: "1.5px rgba(217,244,205,0.18)" }}>
          <Logo />
        </div>

        <div className="mt-8 flex flex-col sm:flex-row items-center justify-between gap-3 border-t border-[#D9F4CD]/15 pt-6">
          <span className="font-mono-eb text-[10px] uppercase tracking-[0.15em] text-[#D9F4CD]/45">
            &copy; {new Date().getFullYear()} TheMacroBar. All rights reserved.
          </span>
          <span className="font-mono-eb text-[10px] uppercase tracking-[0.15em] text-[#D9F4CD]/45">
            Fuel on demand {"\u2014"} Vadodara, India
          </span>
        </div>
      </div>
    </footer>
  );
}
